import type { ReactNode } from 'react';
import { Icon } from '../design';
import './auth.css';

const YEAR = new Date().getFullYear();

/** Logo hai bản: chữ navy trên nền sáng, chữ trắng trên nền tối (CSS chọn theo chế độ màu). */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <span className={['auth-logo', className].filter(Boolean).join(' ')} role="img" aria-label="7wChat">
      <img className="on-light" src="/brand/logo.webp" alt="" width={213} height={53} />
      <img className="on-dark" src="/brand/logo-light.webp" alt="" width={213} height={53} />
    </span>
  );
}

const FEATURES = [
  { icon: 'lock', title: 'Mã hóa đầu cuối', text: 'Khóa sinh ngay trên thiết bị của bạn — máy chủ không đọc được tin nhắn.' },
  { icon: 'people', title: 'Nhóm, dự án và thông báo công ty', text: 'Trao đổi, chia sẻ tệp và nhận thông báo quan trọng trong một nơi.' },
  { icon: 'shield', title: 'Đăng nhập một lần, quản lý tập trung', text: 'Một tài khoản công ty, kiểm soát thiết bị và phiên đăng nhập.' },
] as const;

/**
 * Khung màn đăng nhập/onboarding (cùng kiểu trang đăng nhập của 7wID): cột giới thiệu tối bên trái, biểu mẫu bên phải
 * trên nền lưới chấm; màn hẹp (≤ 720px) chỉ còn biểu mẫu kèm logo phía trên.
 */
export function AuthShell({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <main className="auth-page" data-testid={testId}>
      <section className="auth-brand-panel" aria-hidden="true">
        <BrandLogo className="auth-lockup" />
        <div className="auth-story">
          <span className="auth-eyebrow">TRÒ CHUYỆN NỘI BỘ AN TOÀN</span>
          <h1>
            Trao đổi nhanh.
            <br />
            Bảo mật trọn vẹn.
          </h1>
          <p>Tin nhắn mã hóa đầu cuối — chỉ thiết bị của người tham gia đọc được. Công ty và máy chủ không giữ khóa của bạn.</p>
          {FEATURES.map((f) => (
            <div className="auth-feature" key={f.icon}>
              <span>
                <Icon name={f.icon} size={18} />
              </span>
              <div>
                <b>{f.title}</b>
                <small>{f.text}</small>
              </div>
            </div>
          ))}
        </div>
        <p className="auth-copyright">© {YEAR} 7wChat · Bảo mật cấp doanh nghiệp</p>
      </section>
      <section className="auth-form-panel">
        <div className="auth-card">
          <BrandLogo className="auth-mobile-brand" />
          {children}
        </div>
      </section>
    </main>
  );
}
